<div class="page-auth"></div>
<div class="back-login">
  <main>
    <div class="row">
      <h1>Gestão Credipontal</h1>
    </div>
    <div class="row">
      <h2>Controle, agilidade, gestão...</h2>
    </div>   
    <div class="outline">
      <img
        class="logoSicoob"
        src="../../../assets/icons/icon-128x128.png"
        alt="Logotipo do Sicoob"
      />
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()">
        <div>
          <div class="separator">Login</div>
          <br/>
          <div class="body-login">
            <div class="row-login">
            <mat-form-field
              class="margin-top"
              appearance="outline"
              fxFlex="100"
            >
            <mat-label>Usuário</mat-label>
              <input matInput #inputNomeUsuario formControlName="nomeusuario" />
            </mat-form-field>
          </div>
          <div class="row-login">
            <mat-form-field appearance="outline" fxFlex="100">
              <mat-label>Senha</mat-label>
              <input
                type="password"
                matInput
                id="inputSenha"
                formControlName="senha"
              />
              <!-- <button
                mat-icon-button
                matSuffix
                (click)="passwordVisibility($event)"
              >
                <mat-icon>{{ iconePassword }}</mat-icon>
              </button> -->
            </mat-form-field>
          </div>
          </div>

        </div>
        <div class="waiting">
          <button
            *ngIf="isBusy === false"
            mat-button
            class="btnLogin mat-elevation-z8"
            [disabled]="formulario.status == 'INVALID' || formulario.pristine"
            type="submit"
          >
            Entrar
          </button>
        </div>
      </form>
      <!-- <div class="versao" *ngIf="versao !== null && versao !== undefined">
        Versão {{ versao }}
      </div> -->
    </div>
    <div class="somos-feitos">
      <div class="faixa-verde"></div>
      <h5>Somos feitos de</h5>
      <h3>VALORES</h3>
      <div class="faixa-verde"></div>
    </div>
    <div class="logo-credipontal">
      <img
        src="../../../assets/imagens/credipontal_white.png"
        alt="Imagem da Sicoob Credipontal"
      />
    </div>
  </main>
</div>
